// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2_f9K","info":"UpdateTermsInfo_info__2Tcm9"};